import { render, staticRenderFns } from "./BrosurList.vue?vue&type=template&id=c568f316"
import script from "./BrosurList.vue?vue&type=script&lang=js"
export * from "./BrosurList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports